type Rgb = [number, number, number];

export type AccentVars = {
  '--color-accent': string;
  '--color-accent-hover': string;
  '--color-accent-muted': string;
  '--color-text-on-accent': string;
};

function toRgb(hex: string): Rgb {
  const n = parseInt(hex.slice(1), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

function toHex(rgb: Rgb): string {
  return `#${rgb.map((c) => Math.round(c).toString(16).padStart(2, '0')).join('')}`;
}

// Aproxima cada canal de `target` (255 = branco, 0 = preto) na proporção `amount`.
function mix(rgb: Rgb, target: number, amount: number): Rgb {
  return rgb.map((c) => c + (target - c) * amount) as Rgb;
}

// Luminância relativa (percebida) do canal — decide se o texto por cima da cor de destaque
// precisa ser claro ou escuro para manter contraste legível (ex.: nota selecionada na pesquisa
// NPS). Fórmula simplificada (sem correção gama da WCAG completa), suficiente pra essa decisão
// binária claro/escuro — não usada para cálculo de contraste formal.
function relativeLuminance([r, g, b]: Rgb): number {
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
}

export function deriveAccentVars(hex: string): { dark: AccentVars; light: AccentVars } {
  const accent = hex.toLowerCase();
  const rgb = toRgb(accent);
  const [r, g, b] = rgb;
  const textOnAccent = relativeLuminance(rgb) > 0.5 ? '#0f172a' : '#ffffff';

  return {
    dark: {
      '--color-accent': accent,
      '--color-accent-hover': toHex(mix(rgb, 255, 0.25)),
      '--color-accent-muted': `rgba(${r},${g},${b},0.1)`,
      '--color-text-on-accent': textOnAccent,
    },
    light: {
      '--color-accent': accent,
      '--color-accent-hover': toHex(mix(rgb, 0, 0.15)),
      '--color-accent-muted': `rgba(${r},${g},${b},0.08)`,
      '--color-text-on-accent': textOnAccent,
    },
  };
}
